import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { styled } from '@mui/system';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { useTranslation } from '@hooks';
import { SYNC_BADGE, SYNC_VIEW } from '@constants/profiles';
import { RoutePath } from '@constants/routes';
import { STATUS_FILL } from '@helpers/profileSync';
import MetricItem from './MetricItem';

const CardsWrapper = styled('div')({
    display: 'grid',
    gridGap: 16,
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    height: 'calc(100% - 57px)',
    '@media (max-width: 375px)': {
        gridTemplateColumns: 'repeat(1, 1fr)',
    },
});

const SyncedIcon = styled(CheckCircleIcon)({
    color: STATUS_FILL[SYNC_BADGE.SYNCED],
});

const ConflictIcon = styled(ErrorIcon)({
    color: STATUS_FILL[SYNC_BADGE.CONFLICT],
});

const NotPublishedIcon = styled(CancelIcon)({
    color: STATUS_FILL[SYNC_BADGE.NOT_FOUND],
});

const Synchronization = () => {
    const { t } = useTranslation();
    const { profilesSync } = useSelector(state => state.dashboard.dashboard);
    const loaded = useSelector(state => state.dashboard.loaded);
    const navigate = useNavigate();

    const linkTo = view => `${RoutePath.LocationsProfiles}?view=[${view}]`;

    const data = [
        {
            id: 0,
            title: t('common.synced'),
            value: profilesSync.synced,
            icon: <SyncedIcon />,
            onClick: () => navigate(linkTo(SYNC_VIEW.SYNCED)),
        },
        {
            id: 1,
            title: t('common.conflicts'),
            value: profilesSync.conflicts,
            icon: <ConflictIcon />,
            onClick: () => navigate(linkTo(SYNC_VIEW.CONFLICT)),
        },
        {
            id: 2,
            title: t('common.notPublished'),
            value: profilesSync.notPublished,
            icon: <NotPublishedIcon />,
            onClick: () => navigate(linkTo(SYNC_VIEW.NOT_PUBLISHED)),
        },
    ];

    return (
        <CardsWrapper>
            {data.map(item => (
                <MetricItem
                    key={item.id}
                    value={item.value}
                    title={item.title}
                    withBorder
                    Icon={item.icon}
                    onClick={item.onClick}
                    loading={!loaded}
                />
            ))}
        </CardsWrapper>
    );
};

export default Synchronization;
